import { type ChangeEvent, type MouseEvent, type PointerEvent } from 'react';
import { Product } from '@/models/Product';

export type PhotoPrintStep =
  | 'products'
  | 'source'
  | 'camera'
  | 'customizePrompt'
  | 'crop'
  | 'filter'
  | 'preview';

export type PhotoPrintSource = 'camera' | 'gallery' | null;
export const PHOTO_PRINT_CAPTION_STYLE = {
  CLASSIC: 'classic',
  HANDWRITING: 'handwriting',
  TYPEWRITER: 'typewriter',
} as const;

export type PhotoPrintTextStyle =
  (typeof PHOTO_PRINT_CAPTION_STYLE)[keyof typeof PHOTO_PRINT_CAPTION_STYLE];
export type PhotoPrintFilter = 'original' | 'vintage' | 'warm' | 'cool' | 'bw';

export interface ProductWithCount {
  product: Product;
  count: number;
}

export interface PhotoPrintDraft {
  selectedProduct?: Product;
  step: PhotoPrintStep;
  source: PhotoPrintSource;
  originalImage: string | null;
  editedImage: string | null;
  crop: {
    rotation: number;
    flipped: boolean;
    aspectRatio: '2:3' | 'fit';
  };
  zoom: number;
  filter: PhotoPrintFilter;
  brightness: number;
  contrast: number;
  saturation: number;
  caption: string;
  textStyle: PhotoPrintTextStyle;
  sendWithoutText: boolean;
  quantity: number;
  confirmed: boolean;
  isAddedToBasket: boolean;
  basketItemId?: number | string | null;
  basketPhotoPrintId?: number | string | null;
}

export type PhotoPrintButtonEvent = MouseEvent<HTMLButtonElement> | PointerEvent<HTMLButtonElement>;

export type PhotoPrintInputChangeEvent = ChangeEvent<HTMLInputElement>;
